import { RacemapColors } from '@racemap/utilities/consts/common';
import { ConfigProvider, type ConfigProviderProps, type ThemeConfig, theme } from 'antd';
import { createElement } from 'react';

const { getDesignToken } = theme;

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: RacemapColors.PaleBlue,
    borderRadius: 3.5,
    colorBorder: RacemapColors.Gray,
    colorLink: RacemapColors.PaleBlue,
  },
  components: {
    Form: {
      labelColor: '#212529',
    },
    Table: {
      borderColor: RacemapColors.Gray,
      rowSelectedBg: RacemapColors.LightBlue,
    },
    Card: {
      colorBorderSecondary: RacemapColors.Gray,
    },
    Button: {
      colorLink: RacemapColors.PaleBlue,
      defaultColor: RacemapColors.PaleBlue,
    },
    Layout: {
      bodyBg: 'transparent',
      siderBg: 'transparent',
    },
  },
};

// Everything every entry point passes to ConfigProvider. Spread it rather than passing
// `theme` alone, so global config that is not a theme token — antd 6's per-component
// `styles`/`classNames` slots — has one home instead of eight.
export const antdConfig = {
  theme: themeConfig,
  // Form has no labelFontWeight token, so the bold label lives here.
  form: { styles: { label: { fontWeight: 600 } } },
} satisfies ConfigProviderProps;

// Repeated nested overrides. Scoped on purpose: these must not apply app-wide.
export const largeControlsTheme: ThemeConfig = {
  token: { controlHeight: 48, fontSize: 16 },
};
/** Phones: below antd's `md` breakpoint. */
export const MobileQuery = '(max-width: 767px)';

/** 44px touch targets; 16px inputs keep iOS from zooming in on focus. */
export const mobileControlsTheme: ThemeConfig = {
  token: { controlHeight: 44 },
  components: { Input: { inputFontSize: 16 } },
};
export const compactTableTheme: ThemeConfig = {
  components: { Table: { cellPaddingBlockSM: 4 } },
};

// static theme to use outside of react lifecycle
export const staticThemeToken = getDesignToken(themeConfig);

// antd's static APIs (notification, message, Modal.confirm) render outside the ConfigProvider
// tree and would otherwise ignore themeConfig entirely. holderRender re-wraps them, so toasts
// fired from zustand reducers look like the rest of the app. Every entry point imports this
// module, so configuring it here covers all of them.
ConfigProvider.config({
  holderRender: (children) => createElement(ConfigProvider, antdConfig, children),
});
